/** DOM id of one option row, for `aria-activedescendant`. */
export function optionDomId(listId: string, queueId: string): string {
  return `${listId}-opt-${queueId}`;
}
